const quickViewDefaults = {
    sectionId: null,
    collectionHandle: '',
    useCollectionContext: false,
    rootUrl: '/',
    enabled: false,
    buttonLabel: '',
    show_atc_button: false,
    cart_button_style: 'button',
    cart_always_visible: false,
    atc_btn_bottom: false,
  };

  const initQuickViewStore = () => {
    if (!window.xQuickView || Alpine.store('xQuickView')) {
      return;
    }

    const config = Object.assign({}, quickViewDefaults, window.xQuickView || {});
    Alpine.store('xQuickView', {
      sectionId: config.sectionId,
      collectionHandle: config.collectionHandle,
      useCollectionContext: config.useCollectionContext,
      rootUrl: config.rootUrl,
      enabled: config.enabled,
      buttonLabel: config.buttonLabel,
      show_atc_button: config.show_atc_button,
      cart_button_style: config.cart_button_style,
      cart_always_visible: config.cart_always_visible,
      btn_atc_bottom: config.atc_btn_bottom,
      show: false,
      loading: false,
      currentVariant: '',
      currentRequestUrl: '',
      activeTrigger: null,
      cachedResults: [],
      cachedfetch: [],
      loadedChooseOptions: [],
      loadedChooseOptionsID: [],
      selected: false,
      loadingChooseOption: false,
      addListener() {
        document.addEventListener('eurus:cart:items-changed', () => {
          this.cachedResults = [];
        });
      },
      showBtn(enable, showATCButton, textBtn) {
        this.enabled = enable;
        this.buttonLabel = textBtn;
        this.show_atc_button = showATCButton;
      },
      getVariant(optionId) {
        const variantElement = document.getElementById('current-variant-' + optionId);
        if (!variantElement) {
          return '';
        }

        return variantElement.innerText.trim();
      },
      getLocaleRootPath() {
        const rootPath = (this.rootUrl || '/').replace(window.location.origin, '').split('?')[0].replace(/\/$/, '');
        return rootPath === '/' ? '' : rootPath;
      },
      normalizeProductPath(url) {
        const localeRootPath = this.getLocaleRootPath();
        const parsedUrl = new URL(url || '/', window.location.origin);
        let productPath = parsedUrl.pathname || '/';

        if (localeRootPath && productPath !== localeRootPath && productPath.indexOf(`${localeRootPath}/`) !== 0) {
          productPath = `${localeRootPath}${productPath}`;
        }

        const productPathWithoutLocale = localeRootPath && productPath.indexOf(`${localeRootPath}/`) === 0
          ? productPath.slice(localeRootPath.length)
          : productPath;
        const hasCollectionContext = productPathWithoutLocale.indexOf('/collections/') === 0;

        if (this.useCollectionContext && this.collectionHandle && !hasCollectionContext) {
          productPath = `${localeRootPath}/collections/${this.collectionHandle}${productPathWithoutLocale}`;
        }

        return productPath.replace(/\/{2,}/g, '/');
      },
      buildSectionUrl(url, params = {}) {
        const productUrl = new URL(this.normalizeProductPath(url), window.location.origin);

        Object.keys(params).forEach((key) => {
          if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
            productUrl.searchParams.set(key, params[key]);
          }
        });

        return `${productUrl.pathname}${productUrl.search}`.replace(/\s+/g, '');
      },
      buildProductUrl(url, optionId) {
        return this.buildSectionUrl(url, {
          variant: this.getVariant(optionId),
          section_id: this.sectionId,
          quickview_request: '1'
        });
      },
      getQuickViewTarget() {
        return document.getElementById('quickview-product-content');
      },
      activateInjectedScripts(root) {
        if (!root) {
          return;
        }

        Array.from(root.querySelectorAll('script')).forEach((script) => {
          const type = (script.getAttribute('type') || '').trim();
          const isExecutableInlineScript = !script.src && (
            type === ''
            || type === 'text/javascript'
            || type === 'application/javascript'
            || type === 'module'
          );

          if (!isExecutableInlineScript) {
            return;
          }

          const executedScript = document.createElement('script');
          Array.from(script.attributes).forEach((attribute) => {
            executedScript.setAttribute(attribute.name, attribute.value);
          });
          executedScript.textContent = script.textContent;
          script.replaceWith(executedScript);
        });
      },
      waitForQuickViewAssets() {
        if (!window.Eurus || typeof window.Eurus.loadQuickViewAssets !== 'function') {
          return Promise.resolve();
        }

        const assetPromise = window.Eurus.loadQuickViewAssets();
        window.Eurus.quickViewAssetsReady = assetPromise;
        return assetPromise;
      },
      setTriggerLoading(el, isLoading = true) {
        const trigger = el || this.activeTrigger;

        if (!trigger) {
          return;
        }

        if (isLoading) {
          if (this.activeTrigger && this.activeTrigger !== trigger) {
            this.setTriggerLoading(this.activeTrigger, false);
          }

          this.activeTrigger = trigger;
          trigger.classList.add('quick-view-trigger-loading');
          trigger.setAttribute('aria-busy', 'true');

          if (trigger.tagName === 'BUTTON') {
            trigger.dataset.quickViewDisabled = trigger.disabled ? 'true' : 'false';
            trigger.disabled = true;
          }

          return;
        }

        trigger.classList.remove('quick-view-trigger-loading');
        trigger.removeAttribute('aria-busy');

        if (trigger.tagName === 'BUTTON') {
          if (trigger.dataset.quickViewDisabled !== 'true') {
            trigger.disabled = false;
          }

          delete trigger.dataset.quickViewDisabled;
        }

        if (trigger === this.activeTrigger) {
          this.activeTrigger = null;
        }
      },
      injectContent(productUrl) {
        const quickViewTarget = this.getQuickViewTarget();
        const content = this.cachedResults[productUrl];

        if (!quickViewTarget) {
          console.warn('Quick view target container not found in current page', productUrl);
          return false;
        }

        if (!content) {
          return false;
        }

        quickViewTarget.innerHTML = content;
        this.activateInjectedScripts(quickViewTarget);
        return true;
      },
      load(url, el, optionId) {
        const productUrl = this.buildProductUrl(url, optionId);

        if (this.cachedResults[productUrl]) {
          if (this.currentRequestUrl === productUrl && this.show) {
            this.injectContent(productUrl);
          }

          return Promise.resolve(true);
        }

        if (this.cachedfetch[productUrl]) {
          return this.cachedfetch[productUrl].then((loaded) => {
            if (loaded && this.currentRequestUrl === productUrl && this.show) {
              this.injectContent(productUrl);
            }

            return loaded;
          });
        }

        const request = fetch(productUrl)
          .then(response => {
            if (!response.ok) {
              throw new Error(`Quick view request failed (${response.status}) for ${productUrl}`);
            }
            return response.text();
          })
          .then((response) => {
            const parser = new DOMParser();
            const parsedDocument = parser.parseFromString(response,'text/html');
            const quickViewContent = parsedDocument.getElementById("quickview-product-content");
            if (!quickViewContent) {
              console.warn('Quick view content container not found in section response', productUrl);
              return false;
            }

            const content = quickViewContent.innerHTML;
            this.cachedResults[productUrl] = content;

            if (this.currentRequestUrl === productUrl && this.show) {
              this.injectContent(productUrl);
            }

            return true;
          })
          .catch((error) => {
            console.warn(error);
            return false;
          })
          .finally(() => {
            delete this.cachedfetch[productUrl];
          });

        this.cachedfetch[productUrl] = request;
        return request;
      },
      openWithLoad(url, el, optionId) {
        const productUrl = this.buildProductUrl(url, optionId);

        this.currentRequestUrl = productUrl;
        this.setTriggerLoading(el, true);

        const request = this.cachedResults[productUrl]
          ? Promise.resolve(true)
          : this.load(url, el, optionId);

        return Promise.all([request, this.waitForQuickViewAssets()])
          .then(([loaded]) => {
            if (!loaded || this.currentRequestUrl !== productUrl) {
              return false;
            }

            const injected = this.injectContent(productUrl);

            if (injected) {
              this.open();
              return true;
            }

            return false;
          })
          .finally(() => {
            if (this.activeTrigger === el) {
              this.setTriggerLoading(el, false);
            }
          });
      },
      async loadChooseOptions(url, el, optionId, index) {
        const variantElement = document.getElementById('current-variant-' + optionId);
        const getVariant = variantElement ? variantElement.innerText.trim() : '';
        let urlProduct = this.buildSectionUrl(url, {
          variant: getVariant,
          section_id: 'choose-option',
          page: index
        });
        
        let destinationElm = document.getElementById('choose-options-' + optionId).querySelector('.choose-options');
        let destinationElmMobile = document.getElementById('choose-options-mobile');
        let loadingEl = document.getElementById('choose-options-' + optionId).querySelector('.icon-loading');

        
        if ( this.loadedChooseOptions[urlProduct]) {
          await this.waitForQuickViewAssets();
          if (window.innerWidth > 767) {
            destinationElm.innerHTML = this.loadedChooseOptions[urlProduct];
            destinationElmMobile.innerHTML = '';
          } else {
            destinationElm.innerHTML = '';
            destinationElmMobile.innerHTML = this.loadedChooseOptions[urlProduct];
          }
          return true;
        }
        
        try {
          if (loadingEl) {
            loadingEl.classList.remove('hidden');
          }
          this.loadingChooseOption = true;
          const [response] = await Promise.all([
            fetch(urlProduct),
            this.waitForQuickViewAssets()
          ]);
          const content = await response.text();
      
          const parser = new DOMParser();
          const parsedContent = parser.parseFromString(content, 'text/html').getElementById("choose-options-content").innerHTML;
          
          if (parsedContent) {
            if (window.innerWidth > 767) {
              destinationElm.innerHTML = parsedContent;
              destinationElmMobile.innerHTML = '';
            } else {
              destinationElm.innerHTML = '';
              destinationElmMobile.innerHTML = parsedContent;
            }
            this.loadedChooseOptions[urlProduct] = parsedContent;
          }
          if (loadingEl) {
            loadingEl.classList.add('hidden');
          }
          this.loadingChooseOption = false;
        } catch (error) {
          console.log(error);
        }
      },
      
      open() {
        this.show = true;
        Alpine.store('xPopup').open = true;
      },
      close() {
        this.show = false;
        this.currentRequestUrl = '';
        this.setTriggerLoading(null, false);
        Alpine.store('xPopup').open = false;
      },
      focusQuickView(quickView, btnClose) {
        if ( !this.selected ) { 
          Alpine.store('xFocusElement').trapFocus(quickView, btnClose);
        }
      },
      removeFocusQuickView() {
        if ( !this.selected ) { 
          const elementActive = document.getElementById("button_quickview");
          Alpine.store('xFocusElement').removeTrapFocus(elementActive);
        }
      },
      closePopupMobile() {
        this.openPopupMobile = false;
      },
      showChooseOption() {
         this.openPopupMobile = true;
      }
    });
  };

if (window.Alpine) {
  initQuickViewStore();
} else {
  document.addEventListener('alpine:init', initQuickViewStore);
}
